/* istanbul ignore file */
import { SvgIcon, SvgIconProps } from '@mui/material';

export const InstaSignIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} viewBox="0 0 16 16">
            <rect width="16" height="16" rx="3" />
            <path
                d="M8 11.3333H11.75M9.875 4.45835C10.0408 4.29259 10.2656 4.19946 10.5 4.19946C10.6161 4.19946 10.731 4.22233 10.8382 4.26674C10.9455 4.31116 11.0429 4.37627 11.125 4.45835C11.2071 4.54042 11.2722 4.63786 11.3166 4.7451C11.361 4.85234 11.3839 4.96727 11.3839 5.08335C11.3839 5.19942 11.361 5.31436 11.3166 5.42159C11.2722 5.52883 11.2071 5.62627 11.125 5.70835L5.91667 10.9167L4.25 11.3333L4.66667 9.66668L9.875 4.45835Z"
                stroke="#F5FAFF"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
